// ======================================================================
// File Name       : enterpriseNotice
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../../constants/actionTypes/enterpriseNotice';

export function getDetailOfNoticeForEnterprise(res) {
  return {
    type: ActionTypes.ENTERPRISE_RECEIVED_NOTICE_SECERN_DETAIL,
    res,
  };
}
